import { Tooltip } from "@components/tooltip-container";
import { useUser } from "@components/user-context";
import { type DataTypeProvider } from "@devexpress/dx-react-grid";
import { formatCurrencyToDollarAmount } from "@features/mmm/utils/formatters";
import { formatting } from "@north-beam/nb-common";
import { useClientSettings } from "@pages/mmm/hooks/use-client-settings";

import { TOTAL_BUDGET_COLUMN_ID } from "../constants";
import { type RebudgetingTableRow } from "../mid-cycle-rebudgeting-table";

export const TotalBudgetDataFormatter = ({
  column,
  row: _row,
  proposedBudgetValue,
}: DataTypeProvider.ValueFormatterProps & { proposedBudgetValue?: number }) => {
  const row = _row as RebudgetingTableRow;
  const { user } = useUser();

  const target =
    column.name === TOTAL_BUDGET_COLUMN_ID
      ? row.data.budgetedSpend
      : proposedBudgetValue;

  return (
    <div className="font-semibold text-xs flex justify-end items-center h-full overflow-hidden pr-4">
      {formatCurrencyToDollarAmount(
        target ?? 0,
        user.currencies.currentCurrency,
      )}
    </div>
  );
};
